export default "__VITE_ASSET__B3tx6fl3__"